import { RouteObject } from 'react-router-dom';
import { NubUserManagement } from './views/NubUserManagement';
import { UserMigrationView } from './views/UserMigrationView';
import { UserSecurityView } from './views/UserSecurityView';
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";

export const nubUserRoutes: RouteObject[] = [
    {
        path: '/admin/nub/users',
        element: <NubUserManagement />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/admin/nub/users/migration',
        element: <UserMigrationView />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/admin/nub/user-security',
        element: <UserSecurityView />,
        errorElement: <ErrorBoundary />,
    }
];